// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';



Vue.use(element)

Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'categoryNum') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}

import less from 'less'
Vue.use(less)

import http from './utils/http';
Vue.prototype.$http = http;


import i18n from './utils/langurage'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})
/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js